
export function wsUri(path) {
    var wsProtocol = (window.location.protocol == 'https:') && 'wss:' || 'ws:'
    var wsHost = window.location.host
    return wsProtocol + '//' + wsHost + path
}


// WEBPACK FOOTER //
// ./lib/core/websocketz.js